<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Usuarios del sistema</h1>
      </div>
    </div>
    <div class="content__row">
      <user-list :filters="filters"></user-list>
      <user-view :user="user" v-if="userAction === 'view' && user"></user-view>
      <user-edit :user="user" v-if="userAction === 'edit'" :key="key"></user-edit>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Navegación</h2>
          <router-link class="btn btn__action btn--small" :to="{name: 'home'}">Roles</router-link>
          <h2 class="content__subtitle">Filtro</h2>
          <div class="form__container">
            <label for="search" class="form__label">búsqueda Libre</label>
            <input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters">
          </div>
        </div>
      </div>
    </div>
    <button @click.prevent="newUser" class="btn btn__add">Agregar</button>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import userList from './list'
import userView from './view'
import userEdit from './edit'
export default {
  mixins: [
    httpService
  ],
  components: {
    userList,
    userView,
    userEdit
  },
  data: function () {
    return {
      key: 0,
      userAction: null,
      search: null,
      user: null,
      filters: undefined
    }
  },
  mounted: function () {
    this.$on('view',id => {
      this.getUser(id, 'view')
    })
    this.$on('edit',id => {
      this.getUser(id, 'edit')
    })
    this.$on('new',() => {
      this.newUser()
    })
  },
  methods: {
    setFilters: function () {
      let filter = ''
      if (this.search && this.search.length > 1) {
        filter = 'search=' + this.search
      }
      if (filter.length > 0) {
        this.filters = filter
      } else {
        this.filters = undefined
      }
    },
    getUser: function (id, action) {
      this.userAction = action
      let httpRequest = {
        params: '',
        module: 'users'
      }
      this.getById(id, httpRequest)
        .then(
          user => {
            this.user = user.data
          }
        )
    },
    newUser: function () {
      this.userAction = 'edit'
      this.key = ++this.key
      this.user = undefined
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_home"
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/users/users.vue